module.exports = __webpack_public_path__ + "static/media/header-img.e8257f2f.svg";